import { Icon, TableCell, TableRow } from "@tremor/react";
import PropTypes from "prop-types";
import { DeleteModal, TableComponent, TitleTablePage } from "../components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAdminUsers } from "../../store/admin/thunks";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../ui";
import { MenuLayout } from "../layouts";
import { useAPI } from "../../hooks";

const headers = [
  "Nombre",
  "Correo Electrónico",
  "Teléfono",
  "Perfil",
  "Acciones",
];

const RowTable = ({ name, email, phone, lastName, profile, id }) => {
  const [showModal, setModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { del } = useAPI();
  const goToEdit = () => {
    navigate(`/admin/users/${id}`);
  };

  const showModalDelete = () => {
    setModal(true);
  };

  const closeModalDelete = () => {
    setModal(false);
  };

  const deleteUser = async () => {
    const resp = await del(`/admin/${id}`);
    closeModalDelete();
    dispatch(getAdminUsers());
  };
  return (
    <>
      {showModal && (
        <DeleteModal
          information={`${name} ${lastName}`}
          cancelFunction={closeModalDelete}
          confirmFunction={deleteUser}
        />
      )}
      <TableRow>
        <TableCell>
          {name} {lastName}
        </TableCell>
        <TableCell>{email}</TableCell>
        <TableCell>{phone}</TableCell>
        <TableCell>{profile.name}</TableCell>
        <TableCell>
          <Icon variant="solid" icon={PencilSquareIcon} onClick={goToEdit} />

          <Icon
            variant="solid"
            icon={TrashIcon}
            className="ml-1"
            onClick={showModalDelete}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export const AdminPage = () => {
  const dispatch = useDispatch();

  const {
    adminUsers = [],
    hasError,
    messageError,
  } = useSelector((state) => state.admin);
  const tableContent = adminUsers.map((d) => <RowTable key={d.id} {...d} />);
  useEffect(() => {
    dispatch(getAdminUsers());
  }, [dispatch]);
  return (
    <>
      <MenuLayout hasError={hasError} messageError={messageError}>
        <TitleTablePage
          title="Usuarios"
          titleBtn="Nuevo Usuario"
          urlToGo="admin/new-user"
        />
        {adminUsers.length > 0 ? (
          <TableComponent
            button=""
            showSelectLogs={true}
            showSearchInput={true}
            tableContent={tableContent}
            tableHeaders={headers}
            title="Usuarios de Administración"
          />
        ) : (
          <Spinner />
        )}
      </MenuLayout>
    </>
  );
};

RowTable.propTypes = {
  name: PropTypes.string,
  lastName: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  profile: PropTypes.object,
  id: PropTypes.number,
};
